import React, { useState, useContext, useEffect, useRef } from 'react';
import { IonLabel, IonImg, IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol } from '@ionic/react';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


function PublicShowcaseModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let newShowcaseCategoryRef = useRef();
    let currentShowcaseCategoryRef = useRef('default');

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showCompanySetting_publicShowcaseModal, setShowCompanySetting_publicShowcaseModal] = useState(false);
    let [showCompanySetting_selectedImageModal, setShowCompanySetting_selectedImageModal] = useState(false);
    let [viewPublicShowcaseData, setViewPublicShowcaseData] = useState([]);
    let [showcaseGalleryTracker, setShowcaseGalleryTracker] = useState(null);
    let [showcaseGalleryTracker_addition, setShowcaseGalleryTracker_addition] = useState(null);
    let [showcaseGalleryTracker_updated, setShowcaseGalleryTracker_updated] = useState(null);
    let [showcaseName, setShowcaseName] = useState(null);
    let [showcaseImagePath, setShowcaseImagePath] = useState(null);
    let [showcaseFormData, setShowcaseFormData] = useState(null);
    let [style_showcaseGalleryView, setStyle_showcaseGalleryView] = useState('zProServiceShowcase_acctGallaryView');
    let [firstSelectedImage, setFirstSelectedImage] = useState(true);
    let [background_selectedShowcaseImage, setBackground_selectedShowcaseImage] = useState(null);
    let [display_addImages, setDisplay_addImages] = useState('inline-block');
    let [display_saveAdditionChanges, setDisplay_saveAdditionChanges] = useState('inline-block');
    let [display_saveDeletionChanges, setDisplay_saveDeletionChanges] = useState('none');
    let [display_background, setDisplay_background] = useState('yellow');
    let [showcaseGallery_deletionSelection, setShowcaseGallery_deletionSelection] = useState([]);
    let [buttonPressTimer, setButtonPressTimer] = useState(null);

    let [showcase_optionCategories, setShowcase_optionCategories] = useState([]);
    let [showcase_newCategoryModal, setShowcase_newCategoryModal] = useState(false);
    let [showcase_currentCategory, setShowcase_currentCategory] = useState(null);



    useEffect(() => {

        let requestOptions2 = {
            method: 'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: "74003C",
                user: acctID,
                xShowcaseCategory: currentShowcaseCategoryRef.current.value,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions2)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            setShowcaseGalleryTracker(rows.length - 1);


            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');



                setViewPublicShowcaseData((prevViewPublicShowcaseData) => {
                    return prevViewPublicShowcaseData.concat({
                        id: cols[0], 
                        location: cols[1], 
                        description: cols[2], 
                        dateAdded: cols[3], 
                        image: cols[4]
                    })
                });
            } 
        })
    }, [currentShowcaseCategoryRef.current]);

    useEffect(() => {

        setShowcase_optionCategories([]);


        let requestOptions1 = {
            method: 'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: "74003CC",
                user: acctID,
                sessionID: sessionID,
            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions1)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            setShowcaseGalleryTracker(rows.length - 1);


            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                for(let colnum = 0; colnum < cols.length - 1; ++ colnum)
                {
                    setShowcase_optionCategories((prevShowcase_optionCategories) => {
                        return prevShowcase_optionCategories.concat({
                            catName: cols[0], 
                            catValue: cols[0], 
                        })
                    });

                }
            } 
        })

    }, []);

    function handleEnterPublicShowcaseImages(e) { 
        
        //alert('Inside handleEnterPublicShowcaseImages');
        //alert(e);
        //alert(e[0]);
       // alert(e[1]);
        //alert(currentShowcaseCategoryRef.value);
        //alert(currentShowcaseCategoryRef.current.value);


        let numOfImages = e[0].target.files.length;
        let aa = showcaseGalleryTracker;
    
        if (e[0].target.files)
        {
    
            let formData = new FormData();
            formData.append('Tracker', '74003D');
            formData.append('user', acctID);

            if(e[1] === '0')
            {
                formData.append('xShowcaseCategory_status', 'new');
                formData.append('xShowcaseCategory', newShowcaseCategoryRef.current.value)
            }
            else if(e[1] === '1')
            {
                formData.append('xShowcaseCategory_status', 'current');
                formData.append('xShowcaseCategory', currentShowcaseCategoryRef.current.value)

            }
    
            for(let i = 1; i <= numOfImages; ++i)
            {
    
                formData.append('xCompanyShowcase'+(aa+i), e[0].target.files[i-1]);
    
            }    
            
            setShowcaseGalleryTracker_addition(numOfImages);
            setShowcaseGalleryTracker_updated( aa+numOfImages);
            setShowcaseFormData(formData);
    
        }
    }

    function handleShowcaseCategory () {

        //setShowcase_currentCategory(event);
        setViewPublicShowcaseData([]);

        let requestOptions2 = {
            method: 'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: "74003C",
                user: acctID,
                xShowcaseCategory: currentShowcaseCategoryRef.current.value,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions2)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            setShowcaseGalleryTracker(rows.length - 1);


            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');



                setViewPublicShowcaseData((prevViewPublicShowcaseData) => {
                    return prevViewPublicShowcaseData.concat({
                        id: cols[0], 
                        location: cols[1], 
                        description: cols[2], 
                        dateAdded: cols[3], 
                        image: cols[4]
                    })
                });
            } 
        })

    }

    function saveShowcaseUpdateAdditions(e)
    {


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            file: showcaseFormData,
            body: showcaseFormData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72001B',
                user: acctID,
                sessionID: sessionID,
            })*/
        }

        fetch("https://ghanaverified.com/hotel_merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            props.onUpdateShowCompanySetting_onlineImageModal(false);
        })

    }

    function saveShowcaseUpdateDeletions(e)
    {

        let formData = new FormData();
        formData.append('Tracker', '74003E');
        formData.append('user', acctID);
        formData.append('sessionID', sessionID);



        showcaseGallery_deletionSelection.map((photoID) => {

            formData.append('xShowcaseImgDeletion'+(photoID.id), photoID.id);
        })

        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            //file: showcaseFormData,
            body: formData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72003E',
                user: acctID,
                sessionID: sessionID,
            })*/
        }

        fetch("https://ghanaverified.com/hotel_merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            props.onUpdateShowCompanySetting_onlineImageModal(false);
        })

    }


    function handleButtonPress(event) 
    {


        let mouseIsDown = event[1];

        if(firstSelectedImage == false)
        {

            setShowcaseGallery_deletionSelection((prevShowcaseGallery_deletionSelection) => {
                return prevShowcaseGallery_deletionSelection.concat({
                    id: event[2], 
                })
            });

            const el = document.querySelector('#zProServiceShowcase_acctGallaryView'+event[2]);
            el.style.setProperty('background', 'green');

        }
        else
        {
            setButtonPressTimer(() => setTimeout(() => {


                setShowcaseGallery_deletionSelection((prevShowcaseGallery_deletionSelection) => {
                    return prevShowcaseGallery_deletionSelection.concat({
                        id: event[2], 
                    })
                });
    
                setFirstSelectedImage(false);
                setDisplay_addImages('none');
                setDisplay_saveAdditionChanges('none');
                setDisplay_saveDeletionChanges('inline-block');

                const el = document.querySelector('#zProServiceShowcase_acctGallaryView'+event[2]);
                el.style.setProperty('background', 'green');

            }, 1000));

        }

    }

    function handleButtonRelease (event) {

        if(firstSelectedImage == true)
        {
            clearTimeout(buttonPressTimer);
            setShowCompanySetting_selectedImageModal(true);
            props.onSetEnlarge_selectedShowcaseImage(event[3]);
        }


      }


      function closeModalHandler(event) {


            setShowCompanySetting_publicShowcaseModal(event);
            setViewPublicShowcaseData([]);
            setShowcaseGallery_deletionSelection([]);
            setFirstSelectedImage(true);
            setDisplay_addImages('inline-block');
            setDisplay_saveAdditionChanges('inline-block');
            setDisplay_saveDeletionChanges('none');
            setShowcaseGalleryTracker_addition(null);
            setShowcaseGalleryTracker_updated(null);
            setShowcaseFormData(null);
            props.closeModal();
    }


    return (
        <React.Fragment>
        <IonModal id='showCompanySetting_publicShowcase' isOpen={props.openModal}>
        <IonGrid >
        <IonRow>
            <IonCol style={{display: display_addImages}}>
                <IonLabel for="showcaseCategory"> Category </IonLabel>
                <select name="showcaseCategory" id='showcaseCategory' ref={currentShowcaseCategoryRef } onChange={ handleShowcaseCategory } >
                    <option value='default'>Default</option>
                    {showcase_optionCategories.map((option) => {
                        return <option value={option.catValue}>{option.catName} </option>;
                    })}
                    <option onClick={() => setShowcase_newCategoryModal(true)}>New Category</option>
                </select>
                <IonModal id='showcase_newCategory' isOpen={showcase_newCategoryModal}>
                    <IonItem>
                        <form >
                            <lable for='categoryName'>Category Name</lable>
                                <input id='categoryName' type='text' placeholder='Showcase Name' ref={newShowcaseCategoryRef }></input>
                            <label for='createMerchantCompanyImage'>Add New Category/Images</label>
                                <input id='createMerchantCompanyImage' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterPublicShowcaseImages([e, '0'])} multiple></input>
                            <label for='noAttachment'>No Attachment</label>
                                <input type='checkbox' id='noAttachment' value='noImage'></input>
                        </form>
                        <IonButton onClick={() => saveShowcaseUpdateAdditions()}> Save Changes </IonButton>
                        <IonButton onClick={() => setShowcase_newCategoryModal(false)}>Cancel</IonButton>
                    </IonItem>
                </IonModal>
            </IonCol>
        <IonRow>
            <IonCol>
                <form >
                    <label for='currentShowcase'>Upload Image</label>
                        <input id='currentShowcase' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterPublicShowcaseImages([e, '1'])} multiple></input>
                    <label for='noAttachment'>No Attachment</label>
                        <input type='checkbox' id='noAttachment' value='noImage'></input>
                </form>
            </IonCol>
        </IonRow>
        </IonRow>
        <IonRow>
            {viewPublicShowcaseData.map((photoData) =>   {
                return (
                    <IonCol id={'zProServiceShowcase_acctGallaryView'+photoData.id} size='4'>
                        <IonText>
                            {photoData.id}
                        </IonText>
                        <IonImg
                            class='zProServiceShowcase_img'
                            src={photoData.image} 
                            onMouseDown={() =>
                                handleButtonPress([
                                    this,
                                    true,
                                    photoData.id,
                                    photoData.image,
                                ])
                            }
                            onMouseUp={() =>
                                handleButtonRelease([
                                    this,
                                    false,
                                    photoData.id,
                                    photoData.image,
                                ])
                            }
                        ></IonImg>
                        <IonText>
                            {'photoData.location' + ' ' + 'photoData.description'}
                        </IonText>
                    </IonCol>
                )
            }
            )}
        </IonRow>
        <IonRow>
            <IonCol>
                <IonButton onClick={() => saveShowcaseUpdateAdditions()} style={{display: display_saveAdditionChanges}}> Save Changes </IonButton>
            </IonCol>
            <IonCol>
                <IonButton onClick={() => saveShowcaseUpdateDeletions()} style={{display: display_saveDeletionChanges}}> Confirm Deletions </IonButton>
            </IonCol>
            <IonCol>
                <IonButton onClick={() => closeModalHandler()}> Cancel </IonButton>
            </IonCol>
        </IonRow>
    </IonGrid>
    </IonModal>
    </React.Fragment>
    )
}

export default PublicShowcaseModal